<style lang="less">
.analysis-teacher {
  background: #f3f3f3;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  .main-1 {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-sizing: border-box;
    .header {
      width: 100%;
      height: 32px;
      position: relative;
      display: flex;
      .search {
        position: absolute;
        width: 600px;
        height: 30px;
        display: flex;
        right: 10px;
      }
    }
    .header-next {
      width: 100%;
      height: 32px;
      position: relative;
      display: flex;
      .class-info {
        width: 72px;
        height: 100%;
        line-height: 32px;
        text-align: center;
      }
      .choose-date {
        margin-left: 100px;
        margin-right: 10px;
        height: 32px !important;
        .ivu-input {
          height: 32px !important;
        }
      }
    }
    .contain-part {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 24px 0;
      box-sizing: border-box;
    }
    .footer {
      width: 100%;
      height: auto;
    }
  }
}
</style>
<template>
  <div class="analysis-teacher">
    <div class="main-1" v-if="showPage == 0">
      <div class="header">
        <div class="search">
          <DatePicker
            :value="dateTimeNew"
            format="yyyy/MM/dd"
            type="daterange"
            placement="bottom-end"
            placeholder="选择起止日期"
            style="width: 200px;height: 32px"
            :options="shortcutsOption"
            @on-clear="ClearTeacherDate"
            @on-change="SetAvgDate"
          />
          <Button
            class="clear-info"
            @click="GetTeacherList"
            style="height: 32px;margin-left:20px;margin-right: 10px;"
            type="info"
            >搜索</Button
          >
          <Input
            @on-search="GetTeacherList"
            @on-change="GetTeacherList"
            v-model="userId"
            clearable
            placeholder="输入老师姓名"
            style="width:200px;"
          />
          <Button
            class="clear-info"
            @click="ClearAll"
            style="height: 32px;margin-left:20px"
            type="primary"
            >重置</Button
          >
        </div>
      </div>
      <div class="contain-part">
        <i-table border :columns="teacherList" :data="showList"/>
        <Table
          style="display: none"
          ref="commonAllTeacher"
          border
          :columns="teacherList"
          :data="downloadTeacherList"
        />
        <Button
          style="margin-top: 12px;"
          v-show="!showDisable"
          type="success"
          @click="PutTeacherList"
        >
          <Icon type="ios-share-outline" />导出作业数据
        </Button>
        <Button
          style="margin-top: 12px;"
          v-show="showDisable"
          type="primary"
          loading
        >
          <Icon type="ios-share-outline" />导出作业数据
        </Button>
      </div>
      <div class="footer">
        <Page
          :total="count"
          :page-size="pageSize"
          :page-size-opts="[10, 20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <!-- 班级明细 -->
    <div class="main-1" v-if="showPage == 1">
      <div class="header-next">
        <Button @click="Reback(0)" type="primary">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="class-info">班级明细</div>
        <Input
          @on-search="GetClassInfo"
          @on-change="GetClassInfo"
          v-model="className"
          clearable
          placeholder="输入班级名称"
          style="width:360px;"
        />
      </div>
      <div class="contain-part">
        <i-table border :columns="classList" :data="classDataList"/>
      </div>
      <div class="footer">
        <Page
          :total="count1"
          :page-size="pageSizeC"
          :page-size-opts="[10, 20]"
          show-total
          @on-change="ChangePageC"
          @on-page-size-change="ChangePageSizeC"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <!-- 学生明细 -->
    <div class="main-1" v-if="showPage == 2">
      <div class="header-next">
        <Button @click="Reback(1)" type="primary">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="class-info">学生明细</div>
        <Input
          @on-search="GetStudentInfo"
          @on-change="GetStudentInfo"
          v-model="studentInfo"
          clearable
          placeholder="输入学生姓名"
          style="width:360px;"
        />
      </div>
      <div class="contain-part">
        <i-table
          border
          :columns="studentList"
          :data="studentDataList"
        />
      </div>
      <div class="footer">
        <Page
          :total="count2"
          :page-size="pageSizeS"
          :page-size-opts="[10, 20]"
          show-total
          @on-change="ChangePageS"
          @on-page-size-change="ChangePageSizeS"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <!-- 作业明细 -->
    <div class="main-1" v-if="showPage == 3">
      <div class="header-next">
        <Button @click="Reback(2)" type="primary">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="class-info">作业明细</div>
        <DatePicker
          class="choose-date"
          :value="dateTime"
          format="yyyy-MM-dd"
          type="daterange"
          placement="bottom-end"
          placeholder="选择起止日期"
          style="width: 280px;height: 32px"
          :options="shortcutsOption"
          @on-change="SetNewAvgDate"
        />
        <Button style="margin-right: 10px;" @click="SearchWork">搜索</Button>
        <Button style="margin-right: 10px;" @click="ClearData">重置</Button>
      </div>
      <div class="contain-part">
        <i-table
          style="display:none"
          border
          :columns="workList"
          ref="commonAllTable"
          :data="downloadList"
        />
        <i-table
          border
          :columns="workList"
          ref="commonTable"
          :data="workDataList"
        />
        <Button
          style="margin-top: 12px;"
          type="primary"
          @click="GetAllGradeList"
        >
          <Icon type="ios-share-outline" />导出作业数据
        </Button>
      </div>
      <div class="footer">
        <Page
          :total="count3"
          :page-size="pageSizeW"
          :page-size-opts="[10, 20]"
          show-total
          @on-change="ChangePageW"
          @on-page-size-change="ChangePageSizeW"
          show-elevator
          show-sizer
        />
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers'
const DAT_MINI_SECOND = 3600 * 1000 * 24
import analysisApi from '@/lib/api/analysis'
import cisTip from '@/components/cisTip.vue'
export default {
  name: 'teacherData',
  data() {
    return {
      userId: '',
      institutionId: '',
      needStudentUid: '',
      className: '',
      studentInfo: '',
      teacherUid: '',
      groupId: '',
      dateTime: [], // 起止日期
      dateTimeNew: [], // 老师页面的起止日期
      buttonSize: 'large',
      showPage: 0,
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      start: 0,
      pageSize: 10,
      startC: 0,
      pageSizeC: 10,
      startS: 0,
      pageSizeS: 10,
      startW: 0,
      pageSizeW: 10,
      downloadList: [], // 导出数据用
      shortcutsOption: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date()
              const start = new Date()
              return [start, end]
            }
          },
          {
            text: '昨天',
            value() {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND)
              end.setTime(end.getTime() - DAT_MINI_SECOND)
              return [start, end]
            }
          },
          {
            text: '过去7天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 7)
              return [start, end]
            }
          },
          {
            text: '过去30天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
              return [start, end]
            }
          }
          // {
          //   text: '过去60天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 60);
          //     return [start, end];
          //   }
          // },
          // {
          //   text: '过去90天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 90);
          //     return [start, end];
          //   }
          // }
        ]
      },
      teacherList: [
        {
          title: '老师ID',
          key: 'user_number'
        },
        {
          title: '老师姓名',
          key: 'teacher_name'
        },
        {
          title: '班级数',
          key: 'group_nums'
        },
        {
          title: '班级人数',
          key: 'stu_nums'
        },
        {
          title: '布置作业数',
          key: 'task_nums'
        },
        {
          title: '作业完成率',
          key: 'completeRate'
        },
        {
          title: '学生口语成绩',
          key: 'dub_score'
        },
        {
          title: '学生习题成绩',
          key: 'exerciseRate'
        },
        {
          title: '总分享作业数',
          key: 'share_num',
          width: 140,
          renderHeader: (h, params) => {
            return h(cisTip, {
              props: {
                text: `总分享作业数`,
                tip: `作业数在学生app版本6.11.0之后开始统计`,
                placement: 'top',
                iconshow: true,
                iconright: true
              }
            })
          }
        },
        {
          title: '分享浏览数',
          key: 'pv_num'
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            const editBtn = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.CheckInfoClass(1, params.row.teacher_uid)
                  }
                },
                props: {
                  type: 'primary'
                }
              },
              '班级明细'
            )
            return h(
              'div',
              {
                style: {}
              },
              [editBtn]
            )
          }
        }
      ],
      classList: [
        {
          title: '班级ID',
          key: 'group_id'
        },
        {
          title: '老师名称',
          key: 'teacher_name'
        },
        {
          title: '班级名称',
          key: 'group_name'
        },
        {
          title: '班级人数',
          key: 'stu_nums'
        },
        {
          title: '布置作业数',
          key: 'task_nums'
        },
        {
          title: '作业完成率',
          key: 'completeRate'
        },
        {
          title: '学生口语成绩',
          key: 'dub_score'
        },
        {
          title: '学生习题成绩',
          key: 'exerciseRate'
        },
        {
          title: '总分享作业数',
          key: 'share_num',
          width: 140,
          renderHeader: (h, params) => {
            return h(cisTip, {
              props: {
                text: `总分享作业数`,
                tip: `作业数在学生app版本6.11.0之后开始统计`,
                placement: 'top',
                iconshow: true,
                iconright: true
              }
            })
          }
        },
        {
          title: '分享浏览数',
          key: 'pv_num'
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            const editBtn = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.CheckWorkInfo(2, params.row.group_id)
                  }
                },
                props: {
                  type: 'primary'
                }
              },
              '学生明细'
            )
            return h(
              'div',
              {
                style: {}
              },
              [editBtn]
            )
          }
        }
      ],
      studentList: [
        {
          title: '学生ID',
          key: 'user_number'
        },
        {
          title: '学生名称',
          key: 'name'
        },
        {
          title: '完成作业数',
          key: 'complete_task_num'
        },
        {
          title: '未完成作业数',
          key: 'unComplele'
        },
        {
          title: '作业平均分',
          key: 'dubbing_total_avg_score'
        },
        {
          title: '总分享作业数',
          key: 'task_shares'
        },
        {
          title: '分享浏览数',
          key: 'task_share_pvs'
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            const editBtn = h(
              'i-button',
              {
                on: {
                  click: () => {
                    this.CheckInfo(3, params.row.uid)
                  }
                },
                props: {
                  type: 'primary'
                }
              },
              '作业明细'
            )
            return h(
              'div',
              {
                style: {}
              },
              [editBtn]
            )
          }
        }
      ],
      workList: [
        {
          title: '作业id',
          key: 'work_id'
        },
        {
          title: '作业名称',
          key: 'title'
        },
        {
          title: '作业类型',
          key: 'workType'
        },
        {
          title: '作业成绩',
          key: 'finalScore'
        },
        {
          title: '是否分享',
          key: 'isShare'
        },
        {
          title: '分享浏览数',
          key: 'share_pvs'
        }
      ],
      showList: [],
      classDataList: [],
      studentDataList: [],
      workDataList: [],
      // 6.21.0新加--老师列表支持日期搜索
      teacherStartTime: '',
      teacherEndTime: '',
      downloadTeacherList: [], // 导出用的数据数组
      showDisable: false
    }
  },
  created() {
    this.GetTeacherList()
    this.GetOrganInfo()
  },
  methods: {
    GetOrganInfo() {
      analysisApi.GetOrgan().then((res) => {
        console.log(res)
        this.institutionId = res.data.institution_id
      })
    },
    ClearAll() {
      this.userId = ''
      this.GetTeacherList()
    },
    ClearData() {
      this.dateTime = []
    },
    // 老师数据分页
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.GetTeacherList()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.GetTeacherList()
    },
    // 班级明细分页
    ChangePageC(index) {
      console.log(this.start)
      this.startC = (index - 1) * this.pageSizeC
      this.GetClassInfo()
    },
    ChangePageSizeC(pageSize) {
      this.pageSizeC = pageSize
      this.GetClassInfo()
    },
    // 学生明细分页
    ChangePageS(index) {
      this.startS = (index - 1) * this.pageSizeS
      this.GetStudentInfo()
    },
    ChangePageSizeS(pageSize) {
      this.pageSizeS = pageSize
      this.GetStudentInfo()
    },
    // 作业明细分页
    ChangePageW(index) {
      this.startW = (index - 1) * this.pageSizeW
      this.GetWorkInfo()
    },
    ChangePageSizeW(pageSize) {
      this.pageSizeW = pageSize
      this.GetWorkInfo()
    },
    CheckInfoClass(page, teacherUid) {
      console.log(teacherUid)
      this.teacherUid = teacherUid
      this.showPage = page
      console.log(this.showPage)
      this.GetClassInfo(teacherUid)
    },
    CheckWorkInfo(page, teacherUid) {
      this.groupId = teacherUid
      this.showPage = page
      console.log(this.showPage)
      this.GetStudentInfo()
    },
    CheckInfo(page, uid) {
      this.showPage = page
      console.log(uid)
      this.needStudentUid = uid
      this.GetWorkInfo()
    },
    GetClassInfo() {
      analysisApi
        .SearchTeacherGroup({
          uid: this.teacherUid,
          keyword: this.className,
          startT: this.startC,
          rowsT: this.pageSizeC
        })
        .then((res) => {
          console.log('班级', res)
          const classInfo = res
          this.list = classInfo.data.list // 所有数据
          this.count1 = classInfo.data.count // 总条数
          this.classDataList = this.list.map((item) => {
            return {
              ...item,
              completeRate:
                parseFloat(item.complete_rate * 100).toFixed(1) + '%',
              exerciseRate: item.exercise_rate + '%'
            }
          })
          console.log(this.classDataList)
        })
    },
    GetStudentInfo() {
      analysisApi
        .SearchGroupData({
          institutionId: this.institutionId,
          id: this.groupId,
          keyword: this.studentInfo,
          startT: this.startS,
          rowsT: this.pageSizeS
        })
        .then((res) => {
          console.log('学生明细', res)
          const classInfo = res
          this.list = classInfo.data.list // 所有数据
          this.count2 = classInfo.data.count // 总条数
          this.studentDataList = this.list.map((item) => {
            return {
              ...item,
              unComplele: item.total_task_num - item.complete_task_num,
              completeRate:
                parseFloat(item.dubbing_total_avg_score * 100).toFixed(1) + '%'
            }
          })
          console.log(this.studentDataList)
        })
    },
    GetWorkInfo() {
      analysisApi
        .SearchWorkData({
          studentUid: this.needStudentUid,
          id: this.groupId,
          keyword: this.studentInfo,
          start: this.startW,
          rows: this.pageSizeW,
          startData:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[0]).format('yyyy-MM-dd'),
          endData:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[1]).format('yyyy-MM-dd')
        })
        .then((res) => {
          console.log('作业明细', res)
          const classInfo = res
          this.list = classInfo.data.list // 所有数据
          this.count3 = classInfo.data.count // 总条数
          this.workDataList = this.list.map((item) => {
            if (item.work_type == 1) {
              item.workType = '跟读作业'
            } else if (item.work_type == 2) {
              item.workType = '配音作业'
            } else if (item.work_type == 3) {
              item.workType = '点读作业'
            } else if (item.work_type == 4) {
              item.workType = '习题作业'
            }
            if (item.is_share == 0) {
              item.share = '否'
            } else {
              item.share = '是'
            }
            if (item.work_type == 4) {
              item.workScore = parseFloat(item.score).toFixed(1) + '%'
            } else {
              item.workScore = item.score
            }
            return {
              ...item,
              workType: item.workType,
              finalScore: item.workScore,
              isShare: item.share
              // completeRate: parseFloat(item.dubbing_total_avg_score * 100).toFixed(1) + "%",
            }
          })
          console.log(this.workDataList)
        })
    },
    Reback(page) {
      this.showPage = page
      this.start = 0
      this.pageSize = 0
    },
    SetNewAvgDate(format) {
      this.dateTime = format
      console.log(this.dateTime)
    },
    ClearTeacherDate() {
      const that = this
      setTimeout(() => {
        that.teacherStartTime = ''
        that.teacherEndTime = ''
        that.dateTimeNew = []
        that.GetTeacherList()
      }, 200)
    },
    SetAvgDate(format) {
      this.dateTimeNew = format
      this.teacherStartTime = ''
      this.teacherEndTime = ''
      const date1 = new Date(format[0])
      const date2 = new Date(format[1])
      this.teacherStartTime = Date.parse(date1) / 1000
      this.teacherEndTime = Date.parse(date2) / 1000
      console.log(this.dateTimeNew)
    },
    SearchWork() {
      this.GetWorkInfo()
    },
    // 导出数据
    GetAllGradeList() {
      analysisApi
        .SearchWorkData({
          studentUid: this.needStudentUid,
          id: this.groupId,
          keyword: this.studentInfo,
          start: this.startW,
          rows: this.count3,
          startData:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[0]).format('yyyy-MM-dd'),
          endData:
            this.dateTime.length == 0
              ? ''
              : new Date(this.dateTime[1]).format('yyyy-MM-dd')
        })
        .then((res) => {
          console.log('作业明细', res)
          const classInfo = res
          this.list = classInfo.data.list // 所有数据
          this.count3 = classInfo.data.count // 总条数
          this.downloadList = this.list.map((item) => {
            if (item.work_type == 1) {
              item.workType = '跟读作业'
            } else if (item.work_type == 2) {
              item.workType = '配音作业'
            } else if (item.work_type == 3) {
              item.workType = '点读作业'
            } else if (item.work_type == 4) {
              item.workType = '习题作业'
            }
            if (item.is_share == 0) {
              item.share = '否'
            } else {
              item.share = '是'
            }
            if (item.work_type == 4) {
              item.workScore = parseFloat(item.score * 100).toFixed(1) + '%'
            } else {
              item.workScore = item.score
            }
            return {
              ...item,
              workType: item.workType,
              finalScore: item.workScore,
              isShare: item.share
              // completeRate: parseFloat(item.dubbing_total_avg_score * 100).toFixed(1) + "%",
            }
          })
          this.$nextTick(function() {
            this.ExportAllData()
          })
        })
    },
    ExportAllData() {
      this.$refs.commonAllTable.exportCsv({
        filename: `学生作业数据`
      })
    },
    // 获取老师列表
    GetTeacherList() {
      analysisApi
        .SearchTeacher({
          keyword: this.userId,
          startT: this.start,
          rowsT: this.pageSize,
          startTime: this.teacherStartTime,
          endTime: this.teacherEndTime
        })
        .then((res) => {
          console.log('老师数据', res)
          const teacherInfo = res
          this.list = teacherInfo.data.list // 所有数据
          this.count = teacherInfo.data.count // 总条数
          this.showList = this.list.map((item) => {
            return {
              ...item,
              completeRate:
                parseFloat(item.complete_rate * 100).toFixed(1) + '%',
              exerciseRate: item.exercise_rate + '%'
            }
          })
          console.log(this.showList)
        })
    },
    // 导出老师数据
    PutTeacherList() {
      this.showDisable = true
      this.$Message.info('正在处理，请勿重复导出')
      analysisApi
        .SearchTeacher({
          keyword: this.userId,
          startT: this.start,
          rowsT: this.count,
          startTime: this.teacherStartTime,
          endTime: this.teacherEndTime
        })
        .then((res) => {
          if (res.status == 1) {
            console.log('老师数据', res)
            const teacherInfo = res
            this.list = teacherInfo.data.list // 所有数据
            this.count = teacherInfo.data.count // 总条数
            this.downloadTeacherList = this.list.map((item) => {
              return {
                ...item,
                completeRate:
                  parseFloat(item.complete_rate * 100).toFixed(1) + '%',
                exerciseRate: item.exercise_rate + '%'
              }
            })
            this.$nextTick(function() {
              this.ExportTeacherData()
            })
            console.log('遍历循环出来之后', this.downloadTeacherList)
          } else {
            this.$Message.info('请求超时')
          }
        })
    },
    ExportTeacherData() {
      this.$refs.commonAllTeacher.exportCsv({
        filename: `老师数据`
      })
      this.showDisable = false
    }
  }
}
</script>
